module.exports = __webpack_public_path__ + "static/img/image067.eb5885b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news7/image067.png
// module id = vlKg
// module chunks = 1